import React from 'react'
import PropTypes from 'prop-types'

import { QuizType } from '../M047Constants'

import M047Introduction from '../M047Introduction/M047Introduction'
import M047SingleSelection from '../M047SingleSelection/M047SingleSelection'
import M047MultiSelectionChip from '../M047MultiSelectionChip/M047MultiSelectionChip'
import M047Summary from '../M047Summary/M047Summary'
import M047MultiSelection from '../M047MultiSelection/M047MultiSelection'
import M047RangeSliderSelection from '../M047RangeSliderSelection/M047RangeSliderSelection'

const M047ViewSwitch = ({
  element,
  navigateToNextPage,
  navigateToPreviousPage,
  updateCurrentElementOptions,
  points,
  startAgain,
  quizType,
}) => {
  switch (element?.type) {
    case 'introduction':
      return <M047Introduction navigateToNextPage={navigateToNextPage} {...element} />
    case 'single-selection':
      return (
        <M047SingleSelection
          navigateToPreviousPage={navigateToPreviousPage}
          navigateToNextPage={navigateToNextPage}
          onChangeCallback={updateCurrentElementOptions}
          quizType={quizType}
          {...element}
        />
      )
    case 'multi-selection':
      return (
        <M047MultiSelection
          navigateToPreviousPage={navigateToPreviousPage}
          navigateToNextPage={navigateToNextPage}
          onChangeCallback={updateCurrentElementOptions}
          {...element}
        />
      )
    case 'multi-selection-chip':
      return (
        <M047MultiSelectionChip
          navigateToPreviousPage={navigateToPreviousPage}
          navigateToNextPage={navigateToNextPage}
          onChangeCallback={updateCurrentElementOptions}
          {...element}
        />
      )
    case 'range-slider-selection':
      return (
        <M047RangeSliderSelection
          navigateToPreviousPage={navigateToPreviousPage}
          navigateToNextPage={navigateToNextPage}
          onChangeCallback={updateCurrentElementOptions}
          {...element}
        />
      )
    case 'summary':
      return <M047Summary points={points} startAgain={startAgain} {...element} />
    default:
      return null
  }
}

M047ViewSwitch.propTypes = {
  element: PropTypes.object,
  navigateToNextPage: PropTypes.func,
  navigateToPreviousPage: PropTypes.func,
  updateCurrentElementOptions: PropTypes.func,
  points: PropTypes.number,
  startAgain: PropTypes.func,
  quizType: PropTypes.oneOf(Object.values(QuizType)),
}

export default M047ViewSwitch
